module.exports = __webpack_public_path__ + "img/download-on-the-app-store-de.b37fbda5.svg";